import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';

export const UndeliverOrderInputSchema = z.object({});

export type UndeliverOrderInput = z.infer<typeof UndeliverOrderInputSchema>;

export const undeliverOrder = async ({ orderId }: { orderId: string }): Promise<void> => {
  return (await api.post(`/orders/${orderId}/undeliver`)).data;
};

type UndeliverOrderOptions = {
  mutationConfig?: MutationConfig<typeof undeliverOrderInvitation>;
};

export const useUndeliverOrder = ({ mutationConfig }: UndeliverOrderOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      // queryClient.refetchQueries({});
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: undeliverOrder,
  });
};
